export const JournalBannerSectionThree = () => {
  return null;
};
